import { Card, type CardProps } from '@mui/material';
import type React from 'react';
import type { CSSProperties, ReactNode } from 'react';
import styles from './CardStyles';

interface CardComponentProps extends Omit<CardProps, 'children'> {
  children: ReactNode;
  style?: CSSProperties;
  display?: string;
}

export default function CardComponent({ children, ...rest }: CardComponentProps): React.ReactElement {
  const classes = styles();
  return (
    <Card className={classes.card} {...rest}>
      {children}
    </Card>
  );
}
